import { Helmet } from "react-helmet-async";
import envConstants from "../Constants";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Reloader from "../Components/reloader";

const TooManyRequest = () => {
    const [timer, setTimer] = useState(30);
    const navigate = useNavigate();

    useEffect(() => {
        // Get last visited URL from sessionStorage
        const lastUrl = sessionStorage.getItem('lastVisitedUrl') || "/";

        const countdown = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer <= 1) {
                    clearInterval(countdown);
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);

        const redirectTimeout = setTimeout(() => {
            navigate(lastUrl);
        }, 45000);

        return () => {
            clearInterval(countdown);
            clearTimeout(redirectTimeout);
        };
    }, [navigate]);

    return (
        <>
            <Helmet>
                <title>Too many requests - {envConstants.STORE_NAME || 'Online Store'}</title>
                <meta name="description" content="Too many requests" />
                <meta name="author" content={envConstants.STORE_META_AUTHOR || 'Auto Part Station Store'} />
                <meta name="keywords" content="Too many requests at Auto Part Station" />
            </Helmet>

            {/* Background Overlay */}
            <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black overlay
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000 // Ensure it appears above everything
            }}>
            </div>
            <div style={{ height: "70vh", overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center", position: "relative", zIndex: 10000 }}>
                <Reloader />
            </div>
        </>
    );
}

export default TooManyRequest;
